///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ChevronDown = ({
  height,
  fill,
  title = messages.chevron.defaultMessage,
  width,
  rotateDegree = 0,
  style,
  ...props
}) => (
  <svg
    aria-labelledby="chevron"
    height={height}
    viewBox="0 0 18 11"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `rotate(${rotateDegree}deg)`, ...style }}
    {...props}
  >
    <title id="chevron-icon">{title}</title>
    <path
      fill={fill}
      d="M16.818.703a.692.692 0 01.98.979L9 10.479.203 1.682a.692.692 0 01.979-.98L9 8.522 16.818.703z"
    />
  </svg>
);

export default ChevronDown;
